<!-- Answers: which games were played most in the selected timeline. -->
<template>
    <section class="panel">
        <h2>Most played games</h2>
        <p class="panel-subtitle">Only games with at least 1 booking (named experience)</p>
        <dashboard-doughnut-chart-host :labels="donutLabels" :data="donutData" />
        <div class="ranking-list">
            <div v-for="game in topGames" :key="`count-${game.name}`">
                <span>{{ game.name }}</span>
                <span>{{ game.count }} ({{ game.percentage }}%)</span>
            </div>
        </div>
    </section>
</template>

<script setup>
import { computed } from "vue";
import DashboardDoughnutChartHost from "./DashboardDoughnutChartHost.vue";

const props = defineProps({
    topGames: {
        type: Array,
        default: () => [],
    },
});

const topSixGames = computed(() => props.topGames.slice(0, 6));
const donutLabels = computed(() => topSixGames.value.map((item) => item.name));
const donutData = computed(() => topSixGames.value.map((item) => item.count));
</script>

<style scoped lang="scss">
@use "../../colors" as *;

.panel {
    box-sizing: border-box;
    margin-top: 1rem;
    min-width: 0;
    width: 100%;
    padding: 1rem 1.25rem 1.25rem;
    border: 1px solid $color-primary;
    border-radius: 0.5rem;
    background: rgba($color-background, 0.71);

    h2 {
        margin: 0 0 0.35rem;
        font-size: 1.1rem;
        color: $color-primary;
        font-weight: 600;
    }
}

.panel-subtitle {
    margin: 0 0 0.9rem;
    color: $color-text-primary;
    font-size: 0.9rem;
}

.ranking-list {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    margin-top: 0.75rem;

    div {
        display: flex;
        justify-content: space-between;
        gap: 0.75rem;
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        padding-bottom: 0.2rem;
    }
}
</style>
